<nb-form-field>
    <input
        #headerInput 
        nbInput
        placeholder="email" 
        type="email" 
        fieldSize="small" 
        [value]="headerText" 
        (focus) = 'onHeaderFocus($event)' 
        (keydown)="onKeyDownEvent($event)"
        (keyup)="onKeyHeader($event)"/>
    <button nbPrefix nbButton ghost *ngIf="headerHasFocus">
        <nb-icon icon="close-outline" pack="eva" (click)="onClearHeader()"></nb-icon>
    </button>
    <button nbSuffix nbButton ghost *ngIf="headerHasChanged">
        <nb-icon icon="checkmark-outline" pack="eva" (click)="onSubmitHeader()"></nb-icon>
    </button>
</nb-form-field>


